import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '../rootReducer';
import gtag from '@/utils/gtag';

/* Action Types */
export const SET_EXPERIMENT = 'la/ui/googleOptimize/SET_EXPERIMENT';
export const SET_ERROR = 'la/ui/googleOptimize/SET_ERROR';

// reducer
export const DEFAULT_STATE = {
    error: null,
    value: null,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SET_EXPERIMENT:
            return {
                ...state,
                value: (action.payload || {}).value,
            };
        case SET_ERROR:
            return {
                ...state,
                error: (action.payload || {}).error,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const googleOptimizeSelector = (state: GlobalState) => state.googleOptimize;

export const experimentDetectionCompleted = createSelector(googleOptimizeSelector, (state) => state.value !== null);
export const isExperimentActive = createSelector(
    googleOptimizeSelector,
    (state) => state.value !== null && state.value !== 0
);

/* ACTION CREATORS */
export const setExperiment = (value: any) => ({ payload: { value }, type: SET_EXPERIMENT });

export const detectExperiment = () => (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        if (experimentDetectionCompleted(state)) {
            return;
        }
        // @ts-ignore
        gtag('event', 'optimize.callback', {
            callback: (value) => {
                dispatch(setExperiment(value));
            },
        });
    } catch (error) {
        dispatch({ payload: { error }, type: SET_ERROR });
    }
};
